/** colors from Style Guide https =//xd.adobe.com/view/fb91dbb6-3dba-4714-8273-78d9ca481c5f-aec2/specs/ */

import { defaultPalette } from './colors';

export enum FontSizes {
  // from Style Guide, px
  xxxsmall = 10,
  xxsmall = 12,
  xsmall = 14,
  small = 16,
  medium = 18,
  large = 20,
  xlarge = 24,
  xxlarge = 32,
  xxxlarge = 40,
  // Common UI font sizes, UI code needs to use these font sizes instead of using the font name directly unless it is too specific
  buttonCompound = small,
  button = xsmall,
  buttonSecondary = xsmall,
  buttonIcon = medium,
  buttonLargeIcon = xxlarge,
  optionIcon = small,
  textPrimary = xsmall,
  caretDown = small,
  input = xsmall,
  inputDescription = xxxsmall,
}

export enum FontWeights {
  fw100 = 100,
  fw200 = 200,
  fw300 = 300,
  fw400 = 400,
  fw500 = 500,
  fw600 = 600,
  fw700 = 700,
  fw800 = 800,
  fw900 = 900,
  fw950 = 950,
  thin = fw100,
  extraLight = fw200,
  light = fw300,
  normal = fw400,
  medium = fw500,
  semiBold = fw600,
  bold = fw700,
  extraBold = fw800,
  black = fw900,
  extraBlack = fw950,
  inputDescription = semiBold,
}

const CardGap = 20;
const CardWidth = 246 + CardGap;
const Monitor8kWidth = 7686;

// Common UI sizes, UI code needs to use these sizes unless it is too specific
export enum Sizes {
  padding = 16,
  modalHeaderPadding = 24,
  height = 32,
  borderRadius = 4,

  buttonHeightLarge = 40,
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  buttonHeightSmall = 24,
  buttonHeightXSmall = 20,
  buttonPaddingTopBottom = 11,
  buttonPaddingLeftRightSmall = 8,
  buttonSplitLeftWidth = 125,
  buttonSplitLeftWidthSmall = 113,
  buttonSplitRightWidth = 38,
  buttonWidth = 164,
  buttonWidthSmall = 150,
  buttonWidthXSmall = 80,

  cardGap = CardGap,
  cardMaxColumnCount = Math.ceil(Monitor8kWidth / (CardWidth + CardGap)),
  cardWidth = CardWidth,
  cardWidthOfWidget = 287,

  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  contentPaddingTop = 40,
  headerHeight = 96,
  navWidth = 240,
  pagesSidePadding = 30,
}

export enum ZIndices {
  first = 9,
  second = 99,
  third = 999,
}

export enum LineHeights {
  xxxsmall = 12,
  xxsmall = 13,
  xsmall = 20,
  medium = '1.5em',
  large = 23,
  xlarge = 24,
  xxlarge = 29,
  xxxlarge = 32,
  xxxxlarge = 35,
  section = '65px',
  normal = 'normal',
}

export enum Transitions {
  short = '300ms',
  medium = '500ms',
  long = '1000ms',
}

export const BoxShadow = `0px 3px 10px ${defaultPalette.gray300_a_50}`;
export const BoxShadowPanel = `0px 3px 6px ${defaultPalette.gray300_a_16}`;
export const BoxShadowBadge = `0px 3px 6px rgb(0 0 0 / 0.16) `;
